/**
 * Bind any button or link to the consent manager using the `data-cc` attribute.
 * This allows you to trigger the consent manager from anywhere on your website.
 * The value of the `data-cc` attribute should be one of the predefined values.
 */
export const cookieConsentAttributes = {
  /**
   * @description
   * Use this value to accept all cookie categories.
   *
   * @example
   *
   * ```html
   * <button type="button" data-cc="accept-all">Accept all categories</button>
   * <a href="#" data-cc={cookieConsentAttributes.acceptAll}>Accept all categories</a>
   * ```
   */
  acceptAll: "accept-all",

  /**
   * @description
   * Use this value to accept the current selection inside the preferences modal.
   *
   * @example
   *
   * ```html
   * <button type="button" data-cc="accept-custom">Accept selection</button>
   * <a href="#" data-cc={cookieConsentAttributes.acceptCustom}>Accept selection</a>
   * ```
   */
  acceptCustom: "accept-custom",

  /**
   * @description
   * Use this value to accept only the necessary cookie categories.
   *
   * @example
   *
   * ```html
   * <button type="button" data-cc="accept-necessary">Reject all categories</button>
   * <a href="#" data-cc={cookieConsentAttributes.acceptNecessary}>Reject all categories</a>
   * ```
   */
  acceptNecessary: "accept-necessary",

  /**
   * @description
   * Use this value to show the consentModal. If the consent modal does not exist, it will be generated on the fly.
   *
   * @example
   *
   * ```html
   * <button type="button" data-cc="show-consentModal">View Consent Modal</button>
   * <a href="#" data-cc={cookieConsentAttributes.showConsentModal}>View Consent Modal</a>
   * ```
   */
  showConsentModal: "show-consentModal",

  /**
   * @description
   * Use this value to show the preferencesModal.
   *
   * @example
   *
   * ```html
   * <button type="button" data-cc="show-preferencesModal">View Preferences Modal</button>
   * <a href="#" data-cc={cookieConsentAttributes.showPreferencesModal}>View Preferences Modal</a>
   * ```
   */
  showPreferencesModal: "show-preferencesModal",
};
